import { CardContent, CardHeader, Stack } from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import Table from "../../../components/Table";
import { useEffect, useState } from "react";
import { FileUpload, FilterAlt } from "@mui/icons-material";
import { deleteData, fetchData, postData } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";
import UploadFile from "../../Utils/UploadFile";
import InsurerPincodeFilterDialog from './components/InsurerPincodeFilterDialog.js';

const InsurerPincodeList = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const currentPage = useSelector(
    (state) => state?.insurerPincodeStore?.currentPage
  );
  const rowsPerPage = useSelector(
    (state) => state?.insurerPincodeStore?.rowsPerPage
  );
  const totalPages = useSelector(
    (state) => state?.insurerPincodeStore?.totalPages
  );

  const [pincodeData, setPincodeData] = useState([]);
  const [isRefresh, setIsRefresh] = useState(false);
  const [search, setSearch] = useState("");
  const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [filterData, setFilterData] = useState({
    isActive: "",
    gInsurerId: "",
    iCityId: "",
  });

  useEffect(() => {
    fetchPincodeList();
  }, [isRefresh, currentPage, rowsPerPage, search]);

  //List API
  const fetchPincodeList = async () => {
    setCircleLoading(true);
    try {

      let url = `/reference/insurer/pincode?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}&gInsurerId=${filterData?.gInsurerId}&iCityId=${filterData?.iCityId}`;
                              
      //for active and inactive status
      if(filterData.isActive !== "") {
        url += `&isActive=${filterData.isActive}`;
      }
  
      const response = await fetchData(url);

      if (response?.success) {
        setPincodeData(response?.data?.items);
        dispatch(setTotalPages(response?.data?.totalPages));
      }
    } catch (error) {
      console.error("Error Fetching Pincode:", error);
      showSnackbar("Error Fetching Insurer Pincode Data","error");
    } finally {
      setCircleLoading(false);
    }
  };

  //bulk file upload api function
  const handleFileUploadSuccess = async (file) => {
    setFileUploading(true)
    setUploadSuccess(false)

    try {
      const formData = new FormData()

      formData.append('file', file)

      const result = await postData(`/reference/motor/insurer/bulkUpload/insurer-pincode`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
      });        

      if (result?.success) {
          setUploadSuccess(true)
          showSnackbar(result?.message,"success");
          setOpenUploadFileDialog(false);
          setClearFileOnSuccess(true);
          fetchPincodeList(); 
      }
      else {
          setUploadSuccess(false);
          showSnackbar('Faiiled to upload file', "error")
      }

    }catch (error) {
      const errorMessage = error?.response?.data?.message;                
      console.error('Upload error:', error || errorMessage)
      showSnackbar(errorMessage, "error")
    } 
    finally {
      setFileUploading(false)
    }
  };

  //delete api function
  const handleDelete = async (row) => {
    setCircleLoading(true);
    try {
      const response = await deleteData(`/reference/insurer/pincode-delete`, {
        ids: [row?.id],
      });
      const responseMessage = response?.message;
      setIsRefresh(!isRefresh);
      if (response?.success) {
        showSnackbar(responseMessage, "success");
      } else {
        showSnackbar(responseMessage, "success");
      }
    } catch (error) {
      showSnackbar(error?.response?.data?.message, "error");
    } finally {
      setCircleLoading(false);
    }
  };

  //Table Mapping
  const pincodeListTable = {
    columns: [
      {
        key: "sno",
        label: "S.No.",
        renderCell: (row) => row.sno,
      },
      {
        key: "city",
        label: "City Name",
        renderCell: (row) => row.city,
      },
      {
        key: "code",
        label: "Code",
        renderCell: (row) => row.code,
      },
      {
        key: "pinCode",
        label: "Pin Code",
        renderCell: (row) => row.pinCode,
      },
      {
        key: "createdAt",
        label: "Created At",
        renderCell: (row) => row.createdAt,
      },
      {
        key: "isActive",
        label: "Status",
        renderCell: (row) => (
          <span>
            {row.isActive ? (
              <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
            ) : (
              <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
            )}
          </span>
        ),
      },
    ],
    rows: pincodeData?.map((pincode, index) => ({
      id: pincode?.id,
      sno: index + 1,
      name: pincode?.name || "",
      code: pincode?.code || "",
      pinCode: pincode?.pinCode || "",
      city: pincode?.city?.name || "",
      isActive: pincode?.isActive,
      createdAt: new Date(pincode?.createdAt).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
    })),
  };

  const handleAddNewPinCode = () => {
    navigate(`/insurer-master/insurer-pincode/add-pincode-insurer`);
  };

  //table actions
  const actions = {
    edit: true,
    view: true,
    delete: true,

    onEdit: (row) => {
      navigate(
        `/insurer-master/insurer-pincode/add-pincode-insurer?pageType=edit&id=${row.id}`
      );
    },
    onView: (row) => {
      navigate(
        `/insurer-master/insurer-pincode/add-pincode-insurer?pageType=view&id=${row.id}`
      );
    },
    onDelete: (row) => handleDelete(row),
  };

  const handlePaginationChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    dispatch(setRowsPerPage(rowsPerPage));
    dispatch(setCurrentPage(1));
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  return (
    <DashboardLayout>
      <CardHeader
        title={
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Insurer PIN Code List
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                List of PIN Code around the world according to Insurers.
              </MaterialTypography>
            </Stack>
            <Stack direction="row" spacing={1}>
               <MaterialButton
              variant="gradient"
              color="dark"
              size="small"
              startIcon={<FilterAlt/>}
              onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                Filter
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FileUpload />}
                onClick={() => setOpenUploadFileDialog(true)}
              >
                Bulk Upload
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddNewPinCode()}
              >
                PinCode
              </MaterialButton>
            </Stack>
          </Stack>
        }
      />
      <CardContent>
        <Table
          columns={pincodeListTable?.columns}
          data={pincodeListTable?.rows}
          actions={actions}
          pagination={{
            totalPages,
            currentPage,
            onPageChange: (page) => handlePaginationChange(page),
            rowsPerPage,
            onRowsPerPageChange: (rowsPerPage) =>
              handleRowsPerPageChange(rowsPerPage),
            rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel="No Pincode found"
          handleSearch={handleSearch}
        />
      </CardContent>
      <UploadFile
      open={openUploadFileDialog}
      setOpen={setOpenUploadFileDialog}
      onUploadSuccess={handleFileUploadSuccess}
      fileTypes={['csv', 'xlsx']}
      fileUploading={fileUploading}
      uploadSuccess={uploadSuccess}
      setUploadSuccess={setUploadSuccess}
      setFileUploading={setFileUploading}
      clearFileOnSuccess={clearFileOnSuccess}
      />
      <InsurerPincodeFilterDialog
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
      filterData={filterData}
      setFilterData={setFilterData}
      onApply={() => {
        setAnchorEl(null);   // close popup
        fetchPincodeList();  // call API after filter applied
      }}
      />
    </DashboardLayout>
  );
};

export default InsurerPincodeList;
